const invertedMessages = {
  Active: 'external.search.identities.active',
  Inactive: 'external.search.identities.inactive',
  'User Name': 'external.search.identities.userName',
  'First Name': 'external.search.identities.firstName',
  'Last Name': 'external.search.identities.lastName',
  Email: 'external.search.identities.email',
  Status: 'external.search.identities.status',
  'Search identities': 'external.search.identities.searchIdentities',
  'Suspended From Import Service': 'external.search.identities.status7',
  'No users found': 'external.search.identities.noUsersFound',
  Filter: 'external.search.identities.filter',
  'Status filter': 'external.search.identities.statusFilter',

  // Shared
  'Open {formName}': 'external.userManagement.label.openForm',
  'Untitled Form': 'external.userManagement.label.untitledForm',

  // Column headers
  Username: 'external.search.identities.column.username',
  'Middle Name': 'external.search.identities.column.middleName',
  'Display Name': 'external.search.identities.column.displayName',
  'Start Date': 'external.search.identities.column.startDate',
  'End Date': 'external.search.identities.column.endDate',
  Manager: 'external.search.identities.column.manager',
  Customer: 'external.search.identities.column.customer',
  'Employee Type': 'external.search.identities.column.employeeType',
  Department: 'external.search.identities.column.department',
  'Employee ID': 'external.search.identities.column.employeeId',
  'Identity Source': 'external.search.identities.column.identitySource',
  'Identity Type': 'external.search.identities.column.identityType',
  Title: 'external.search.identities.column.title',
  City: 'external.search.identities.column.city',
  'Secondary Manager': 'external.search.identities.column.secondaryManager',
  Location: 'external.search.identities.column.location',
} as const;

export default invertedMessages;
